var specialProduct3 = false;
var noSpecialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemTitle.toLowerCase().indexOf('Public tasting'.toLowerCase()) > -1) {
    specialProduct3 = true;
  } else {
    noSpecialProduct3 = true;
  }
}

if (specialProduct3 === true && noSpecialProduct3 === true) {
    skipExcludedCheck = true;
    delete stores[1];
    delete stores[2];
}